<template>
  <div class="material-screen-container main-container">
    <div class="top-container"
         v-animateonscroll="{ enterClass: 'fade-in'}">
      <main-text-block :is-active-mini-paragraph="$isMobile"
                       :config-block="{
                            theme: 'dark'
                         }"
                       :main-title="mainTitle"/>
<!--      <div class="navigation-container" v-if="!$isMobile">-->
<!--        <div class="search-container">-->
<!--          <input-main name-block="navigation-container"-->
<!--                      @focusInput="value => activeSearch = value"-->
<!--                      :info="searchInputInfo"/>-->
<!--          <icon-default :icon="!activeSearch ? 'search' : 'search-active'"/>-->
<!--        </div>-->

<!--        <div :class="['filters-container']">-->
<!--          <icon-arrow-sort :active-sort="sortActive"-->
<!--                           @changeSort="changeSort"/>-->
<!--          <select-main :value="activeSelectTag"-->
<!--                       @changeDropdownList="changeTag"-->
<!--                       class="select-tag-container"-->
<!--                       :placeholder-static="'Тег'"-->
<!--                       :info-list="infoSelectTag"/>-->
<!--          <select-main :value="activeSelectType"-->
<!--                       @changeDropdownList="changeType"-->
<!--                       class="select-type-container"-->
<!--                       :placeholder-static="'Тип'"-->
<!--                       :info-list="infoSelectType"/>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="navigation-container" v-else>-->
<!--        <div :class="['filters-container']">-->
<!--          <select-main :value="activeSelectTag"-->
<!--                       @changeDropdownList="changeTag"-->
<!--                       class="select-tag-container"-->
<!--                       :placeholder-static="'Тег'"-->
<!--                       :info-list="infoSelectTag"/>-->
<!--          <select-main :value="activeSelectType"-->
<!--                       @changeDropdownList="changeType"-->
<!--                       class="select-type-container"-->
<!--                       :placeholder-static="'Тип'"-->
<!--                       :info-list="infoSelectType"/>-->
<!--        </div>-->
<!--        <icon-arrow-sort :active-sort="sortActive"-->
<!--                         @changeSort="changeSort"/>-->
<!--        <div class="search-container">-->
<!--          <input-main name-block="navigation-container"-->
<!--                      @focusInput="value => activeSearch = value"-->
<!--                      :info="searchInputInfo"/>-->
<!--          <icon-default :icon="!activeSearch ? 'search' : 'search-active'"/>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="slider-wrapper"
         v-animateonscroll="{ enterClass: 'fade-in'}">
      <block-img-slider v-if="activeInfoCard"
                        :type="activeInfoCard.type"
                        :img="activeInfoCard?.img">
        <div class="header-container">
<!--          <sub-paragraph :font-family="'Eurostile'"-->
<!--                         :color="'dark-purple'">-->
<!--            {{ activeInfoCard?.date }}-->
<!--          </sub-paragraph>-->
<!--          <transition name="fade-opacity-lazy" mode="out-in">-->
<!--            <div class="tags-container" :key="activeInfoCard?.tag">-->
<!--              <label-custom v-for="(item, index) in activeInfoCard?.tag"-->
<!--                            :key="index"-->
<!--                            :title="item.title"/>-->
<!--            </div>-->
<!--          </transition>-->
        </div>
      </block-img-slider>
      <block-slider v-if="!$isMobile"
                    :active-direction-class="'active-left-direction'"
                    :class-name="'cards-material-wrapper'"
                    :info-cards="filterArray"
                    :is-active-out="isActiveOut"
                    :id-out="idActiveCard"
                    :theme="'dark'"
                    @changeId="changeId">
<!--        <template v-slot:cardItem="item">-->
<!--          <main-paragraph class="main-paragraph-container" :font-family="'Verdana'">-->
<!--            {{ item.item.text }}-->
<!--          </main-paragraph>-->
<!--        </template>-->
      </block-slider>
      <block-slider v-else
                    :active-direction-class="'active-left-direction'"
                    :class-name="'cards-material-wrapper'"
                    :info-cards="filterArray"
                    :theme="'dark'"
                    @changeId="changeId">
<!--        <template v-slot:cardItem="item">-->
<!--          <main-paragraph class="main-paragraph-container" :font-family="'Verdana'">-->
<!--            {{ item.item.text }}-->
<!--          </main-paragraph>-->
<!--        </template>-->
      </block-slider>
    </div>
  </div>
</template>

<script>
import MainTextBlock from "@/components/entities/blocks/MainTextBlock.vue";
import BlockSlider from "@/components/entities/blocks/BlockSlider.vue";
import MainParagraph from "@/components/shared/text/MainParagraph.vue";
import BlockImgSlider from "@/components/entities/blocks/BlockImgSlider.vue";
import SubParagraph from "@/components/shared/text/SubParagraph.vue";
import LabelCustom from "@/components/shared/LabelCustom.vue";
import IconDefault from "@/components/shared/IconDefault.vue";
import IconArrowSort from "@/components/shared/IconArrowSort.vue";
import SelectMain from "@/components/shared/SelectMain.vue";
import InputMain from "@/components/shared/InputMain.vue";

export default {
  name: "MaterialsScreen",
  components: {
    InputMain,
    SelectMain,
    IconArrowSort,
    IconDefault, LabelCustom, SubParagraph, BlockImgSlider, MainParagraph, BlockSlider, MainTextBlock},
  data() {
    return {
      searchInputInfo: {
        id: 0,
        placeholder: 'Введите запрос',
        dataIndex: 'search'
      },
      mainTitle: 'Материалы',
      sortActive: 'default',
      activeSearch: false,
      valueSearch: '',
      activeSelectTag: false,
      activeSelectType: false,
      idActiveCard: 0,
      isActiveOut: false,

      infoSelectTag: [
        {
          title: 'tag 1',
          value: 'tag_1'
        },
        {
          title: 'tag 2',
          value: 'tag_2'
        }
      ],
      infoSelectType: [
        {
          title: 'Видеоматериалы 1',
          value: 'video'
        },
        {
          title: 'Фото 2',
          value: 'photo'
        },
        {
          title: 'Текст 1',
          value: 'text'
        },
      ],

      infoCardStatic: {
        id: 0,
        title: 'Гидропластовый патрон',
        icon: 'arrow-dark',
        date: new Date().toISOString()
      },


      infoCard: []
    }
  },
  computed: {
    infoCards() {
      return [
        {
          id: 0,
          title: 'Гидропластовый патрон',
          icon: 'arrow-dark',
          date: new Date().toISOString(),
          type: 'video',
          img: `materials/video_1.mp4`
        },
        {
          id: 1,
          title: 'Система нулевого базирования',
          icon: 'arrow-dark',
          type: 'video',
          date: new Date().toISOString(),
          img: `materials/video_2.mp4`
        },
        {
          id: 2,
          title: 'Цанговый патрон Clamptor',
          icon: 'arrow-dark',
          type: 'video',
          date: new Date().toISOString(),
          img: `materials/video_3.mp4`
        }
      ]
      // return Array(16).fill(this.infoCardStatic).map((item, index) => ({
      //   ...item,
      //   tag: [{
      //     title: `tag_1_${index}`,
      //     value: 'tag_1'
      //   },
      //     {
      //       title: `tag_2_${index}`,
      //       value: 'tag_2'
      //     }],
      //   type: index % 2 === 0
      //       ? 'video'
      //       : index % 3 === 0
      //           ? 'photo'
      //           : 'text',
      //   idAPI: index,
      //   title: `${ item.title } ${ index }`,
      //   date: this.formatFullDateRu(item.date),
      //   img: `material-${index % 2 === 0 ? 1 : 2}.webp`
      // }));
    },
    filterArray() {
      let filterArr = this.infoCards.filter(item => {
        return (this.activeSelectTag
                ? item.tag.find(item => item.value === this.activeSelectTag)
                : true)
            &&
            (this.activeSelectType
                ? item.type === this.activeSelectType
                : true)
            && (this.valueSearch !== ''
                ? item.title.toLowerCase().includes(this.valueSearch.toLowerCase())
                : true)
      })
      let sortArr = this.sortActive !== 'default'
          ? filterArr.sort((a, b) => this.sortActive === 'asc'
              ? a.idAPI - b.idAPI
              : b.idAPI - a.idAPI
          )
          : filterArr
      return sortArr.map((item, index) => ({
        ...item,
        id: index
      }))
    },
    activeInfoCard() {
      return this.filterArray.find(item => item.id === this.idActiveCard)
    }
  },
  methods: {
    changeId(id) {
      this.idActiveCard = id;
    },
    changeSort(value) {
      this.sortActive = value;
      this.changeActiveCard();
    },
    changeTag(value) {
      this.activeSelectTag = value;
      this.changeActiveCard();
    },
    changeType(value) {
      this.activeSelectType = value;
      this.changeActiveCard();
    },
    changeActiveCard() {
      this.isActiveOut = true;
      this.idActiveCard = this.filterArray[0]?.id
      this.$nextTick(() => {
        this.isActiveOut = false;
      })
    }
  }
}
</script>

<style scoped lang="scss">
.main-container {
  flex-direction: column;

  .top-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;

    .main-block-container {
      align-content: space-between;
    }

    .navigation-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      .search-container {
        position: relative;
        .icon-container {
          top: 50%;
          transform: translateY(-50%);
          right: 0;
          position: absolute;
        }
      }
      .input-container {
        transition: all .3s ease;

        &.not-active-search {
          overflow: hidden;
          width: 0;
          opacity: 0;
        }
      }
      .icon-container {
        cursor: pointer;
      }
      .filters-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        transition: all .3s ease;
        &.not-active-filter {
          overflow: hidden;
          width: 0;
          opacity: 0;
        }
      }
    }

  }


  .slider-container {
    .main-paragraph-container {
      color: var(--color-purple-grey);
    }
  }
}
.block-slider-img-container {
  position: relative;
}
.header-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  z-index: 1;
  .tags-container {
    position: relative;
    display: flex;
    flex-direction: row;
  }

}

@media (max-width: 3024px){
  .main-container {
    padding-top: 100px;
    padding-bottom: 200px;
    row-gap: 40px;

    .top-container {
      .navigation-container {
        column-gap: 24px;
        .search-container {
          .icon-container {
            right: 8px;
          }
        }
        .input-container {
          width: 300px;
        }
        .filters-container {
          column-gap: 24px;
          width: 362px;
        }

        .select-type-container {
          min-width: 210px;
          max-width: 210px;
        }
        .select-tag-container {
          min-width: 80px;
          max-width: 80px;
        }
      }

      .main-block-container {
        max-width: 677px;
      }
    }


    .slider-container {
      &:deep(.card-slider-container) {
        min-width: 444px;
      }
    }
  }
  .header-container {
    width: calc(100% - 80px);
    top: 40px;
    left: 40px;
    .tags-container {
      column-gap: 8px;
    }
  }
}



@media (max-width: 1920px) {
  .main-container {
    padding-top: 85px;
    padding-bottom: 170px;
    row-gap: 40px;

    .top-container {
      .navigation-container {
        column-gap: 24px;
        .input-container {
          width: 300px;
        }
        .filters-container {
          column-gap: 24px;
          width: 328px;
        }

        .select-type-container {
          min-width: 190px;
          max-width: 190px;
        }
        .select-tag-container {
          min-width: 80px;
          max-width: 80px;
        }
      }

      .main-block-container {
        max-width: 617px;
      }
    }


    .slider-container {
      &:deep(.card-slider-container) {
        min-width: 384px;
      }
    }
  }
  .header-container {
    width: calc(100% - 80px);
    top: 40px;
    left: 40px;
    .tags-container {
      column-gap: 8px;
    }
  }
}
@media (max-width: 1600px) {
  .main-container {
    padding-top: 70px;
    padding-bottom: 140px;
    row-gap: 30px;

    .top-container {
      .navigation-container {
        column-gap: 16px;
        .input-container {
          width: 250px;
        }
        .filters-container {
          column-gap: 16px;
          width: 262px;
        }

        .select-type-container {
          min-width: 150px;
          max-width: 150px;
        }
        .select-tag-container {
          min-width: 60px;
          max-width: 60px;
        }
      }

      .main-block-container {
        max-width: 582px;
      }
    }


    .slider-container {
      &:deep(.card-slider-container) {
        min-width: 295px;
      }
    }
  }
  .header-container {
    width: calc(100% - 60px);
    top: 30px;
    left: 30px;
    .tags-container {
      column-gap: 4px;
    }
  }
}
@media (max-height: 800px) {
  .main-container {
    padding-top: 55px;
    padding-bottom: 100px;
    row-gap: 30px;

    .top-container {
      .navigation-container {
        column-gap: 16px;
        .input-container {
          width: 250px;
        }
        .filters-container {
          column-gap: 16px;
          width: 223px;
        }

        .select-type-container {
          min-width: 125px;
          max-width: 125px;
        }
        .select-tag-container {
          min-width: 50px;
          max-width: 50px;
        }
      }

      .main-block-container {
        max-width: 399px;
      }
    }


    .slider-container {
      &:deep(.card-slider-container) {
        min-width: 243px;
      }
    }
  }
  .header-container {
    width: calc(100% - 40px);
    top: 20px;
    left: 20px;
    .tags-container {
      column-gap: 4px;
    }
  }
}

@media (max-width: 1400px) and (min-height: 801px) {

  .main-container {
    padding-top: 70px;
    padding-bottom: 140px;
    row-gap: 30px;

    .top-container {
      .navigation-container {
        column-gap: 16px;
        .input-container {
          width: 250px;
        }
        .filters-container {
          column-gap: 16px;
          width: 262px;
        }

        .select-type-container {
          min-width: 150px;
          max-width: 150px;
        }
        .select-tag-container {
          min-width: 60px;
          max-width: 60px;
        }
      }

      .main-block-container {
        max-width: 582px;
      }
    }


    .slider-container {
      &:deep(.card-slider-container) {
        min-width: 295px;
      }
    }
  }
  .header-container {
    width: calc(100% - 60px);
    top: 30px;
    left: 30px;
    .tags-container {
      column-gap: 4px;
    }
  }

}

@media (max-width: 1133px) {

  .main-container {
    padding-top: 55px;
    padding-bottom: 100px;
    row-gap: 30px;

    .top-container {
      .navigation-container {
        column-gap: 16px;
        .input-container {
          width: 250px;
        }
        .filters-container {
          column-gap: 16px;
          width: 223px;
        }

        .select-type-container {
          min-width: 125px;
          max-width: 125px;
        }
        .select-tag-container {
          min-width: 50px;
          max-width: 50px;
        }
      }

      .main-block-container {
        max-width: 399px;
      }
    }


    .slider-container {
      &:deep(.card-slider-container) {
        min-width: 243px;
      }
    }
  }
  .header-container {
    width: calc(100% - 40px);
    top: 20px;
    left: 20px;
    .tags-container {
      column-gap: 4px;
    }
  }
}
@media (max-width: 769px) {
  .main-container {
    padding-top: 40px;
    padding-bottom: 80px;
    row-gap: 8px;

    .top-container {
      flex-direction: column;
      .navigation-container {
        flex-wrap: wrap;
        width: 100%;
        margin-top: 30px;
        column-gap: 16px;
        .search-container {
          width: 100%;
        }
        .input-container {
          width: 100%;
        }
        .filters-container {
          margin-right: auto;
          column-gap: 16px;
          width: 226px;
        }

        .select-type-container {
          min-width: 150px;
          max-width: 150px;
        }
        .select-tag-container {
          min-width: 60px;
          max-width: 60px;
        }
      }

      .main-block-container {
        max-width: 399px;
      }
    }
  }
  .header-container {
    align-items: flex-start;
    width: calc(100% - 40px);
    top: 20px;
    left: 20px;
    .tags-container {
      flex-direction: column;
      row-gap: 4px;
    }
  }
  //iPhone 14
}

@media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
  //iPhone Plus
}
@media (min-height: 600px) and (max-height: 630px){
  //для экранов 8 плюс
}

@media (max-width: 375px){
  //iPhone 8
}


@media (max-width: 375px) and (min-height: 630px) {
  //iPhone X
}


@media (max-width: 320px) {
  //iPhone SE
}

@media (min-width: 3025px) {

  .main-container {
    padding-top: 180px;
    padding-bottom: 365px;
    row-gap: 60px;

    .top-container {
      .navigation-container {
        column-gap: 56px;
        .input-container {
          margin-right: -12px;
          width: 400px;
        }
        .filters-container {
          column-gap: 56px;
          width: 621px;
        }

        .select-type-container {
          min-width: 350px;
          max-width: 350px;
        }
        .select-tag-container {
          min-width: 135px;
          max-width: 135px;
        }
      }

      .main-block-container {
        max-width: 1075px;
      }
    }


    .slider-container {
      &:deep(.card-slider-container) {
        min-width: 830px;
      }
    }
  }
  .header-container {
    width: calc(100% - 132px);
    top: 66px;
    left: 66px;
    .tags-container {
      column-gap: 24px;
    }
  }
}

</style>